import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Admin from "./pages/Admin";
import LandingPreview from "./pages/LandingPreview";
import TcmAdmin from "./templates/tcm-v1/Admin";
import TcmPreview from "./templates/tcm-v1/Preview";
import {
  HomePage,
  TemplatesPage,
  TemplateDetailPage,
  StartWizardPage,
  OrderSuccessPage,
  PlatformAdminPage,
  NotFoundPage,
} from "./pages/platform";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        <Route path="/templates/:slug" element={<TemplateDetailPage />} />
        <Route path="/start/:slug" element={<StartWizardPage />} />
        <Route path="/order-success" element={<OrderSuccessPage />} />
        <Route path="/preview" element={<Navigate to="/pre/landing-v1" replace />} />
        <Route path="/pre/tcm-v1" element={<TcmPreview />} />
        <Route path="/pre/:slug?" element={<LandingPreview shared />} />
        <Route path="/manage" element={<Admin />} />
        <Route path="/man/tcm-v1" element={<TcmAdmin />} />
        <Route path="/man/:slug?" element={<Admin shared />} />
        <Route path="/platform-admin" element={<PlatformAdminPage />} />
        <Route path="/manage/*" element={<Admin />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
